/* eslint-disable */
require('./image')
